import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/recommendation-modal.css";
import {
  fetchMalwareCredentials,
  fetchMalwareCredentialsAction,
  fetchMalwareCredentialsTotal,
  fetchMalwareCredentialsGraph,
} from "../../actions/leakedCredentials";
import "../../assets/css/details-slider.css";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import AccessPage from "../Shared/accessPage";
import moment from "moment";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import { toastr } from "react-redux-toastr";
import { takeDown } from "../../actions/look-alike";

const MalwareCredentials = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const auth = useSelector((state) => state?.auth?.user);
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const dispatch = useDispatch();
  const [toggleArray, setToggleArray] = useState({});
  const [search, setSearch] = useState("");
  const [domainvalue, setDomains] = useState("");
  const [domainSelected, setDomainSelected] = useState("filterSrcDomain");
  const [compromiseEmployee, setCompromiseEmployee] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState("");
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [limit, setLimit] = useState(10);
  const [sortByFnd, setSortByFnd] = useState('desc');
  const [pwdLength, setPwdLength] = useState('');
  const [workingCredentials, setWorkingCredentials] = useState('');
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('info');
  const [isTicketModal, setTicketModal] = useState(false);
  const [ticketComment, setTicketComment] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const state = useSelector(
    (state) => state?.leakedCredential?.malware?.data?.data
  );
  const domainValue = useSelector(
    (state) => state?.leakedCredential?.malware?.data?.domains
  );
  const totalCount = useSelector(
    (state) => state?.leakedCredential?.malware?.data?.totalMalwareCredentials
  );
  const totalRes = useSelector(
    (state) => state?.leakedCredential?.malwareTotal
  );

  let oldDnsDetails = useSelector(
    (state) => state.leakedCredential?.malwareGraph?.data
  );


  let ipArray = [];
  for (
    let details = 0;
    details < oldDnsDetails?.scanDetails?.length;
    details++
  ) {
    ipArray.push(oldDnsDetails?.scanDetails[details]);
  }
  // if (state) {
  //   ipArray.unshift(state?.length);
  // }

  useEffect(() => {
    if (orgId) {
      fetchMalwareCredentials(orgId, dispatch, page, category, search, domainSelected, domainvalue, startDate, endDate, limit, sortByFnd, pwdLength, workingCredentials);
    } else {
      fetchMalwareCredentials(id, dispatch, page, category, search, domainSelected, domainvalue, startDate, endDate, limit, sortByFnd, pwdLength, workingCredentials);
    }
  }, [orgId, id, dispatch, page, category, search, domainSelected, domainvalue, startDate, endDate, limit, sortByFnd, pwdLength, workingCredentials]);

  useEffect(() => {
    fetchMalwareCredentialsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount]);


  useEffect(() => {
    fetchMalwareCredentialsGraph(id, dispatch);
  }, [id, dispatch]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemediated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green", // Customize the color as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                malwareCredentialsIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchMalwareCredentialsAction(id, dispatch, page, category, search, data);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      malwareCredentialsIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchMalwareCredentialsAction(id, dispatch, page, category, search, data);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      malwareCredentialsIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchMalwareCredentialsAction(id, dispatch, page, category, search, data);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  const getDate = (date) => {
    // let password = date?.split("");
    let _date =
      date?.toString().substr(0, 4) +
      "-" +
      date?.toString().substr(4, 2) +
      "-" +
      date?.toString().substr(6, 2);

    return new Date(_date);
  };

  let response = state;

  const credentialFound60Days = response?.filter(
    (row) =>
      row?.fnd &&
      moment(getDate(row?.fnd)).isAfter(moment().subtract(60, "days")) &&
      moment(getDate(row?.fnd)).isBefore(moment())
  );

  let mapData = state;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/getMalwareCredentials/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Malware Credentials.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const toggleIcon = (_id, value) => {
    let val = toggleArray;
    if (val[_id]) {
      $("#" + _id + "_password").html("******");
      $("#" + _id + "_password_icon").attr("class", "fa fa-eye");
      // fa fa-eye-slash
      delete val[_id];
      setToggleArray({ ...val });
    } else {
      $("#" + _id + "_password").html(value);
      $("#" + _id + "_password_icon").attr("class", "fa fa-eye-slash");
      val[_id] = true;
      setToggleArray({ ...val });
    }
  };

  const clearPassword = () => {
    $("[id$='_password']").html("******");
    $("[id$='_password_icon']").attr("class", "fa fa-eye");
  }

  const reScan = () => {
    let data = {
      "moduleName": ["malwareInfected"]
    }
    rescanSingle(id, data)
  }

  const series = [
    // totalRes?.data?.totalMalwareCredentialsFoundInLast60Days || 0,
    // totalRes?.data?.totalMalwareTypes || 0,
    totalRes?.data?.totalMalwareCredentials || 0
  ];

  const labels = ["Credentials found in last 60 days", "Types of Malware", "Malware Credentials"];

  // Add these new state variables for date picker
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
    clearPassword();
  };

  // Add this function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Handle file upload for ticket
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toastr.error("Error", "File size must be less than 10MB");
        return;
      }
      setUploadedFile(file);
    }
  };


  // Download incident details
  const handleDownloadIncident = () => {
    if (!selectedRowDetails) return;

    try {
      // Format date helper
      const formatDate = (dateValue) => {
        if (!dateValue) return "N/A";
        if (dateValue.includes && dateValue.includes("-")) {
          return moment(dateValue).format("YYYY-MM-DD");
        }
        return moment(getDate(dateValue)).format("YYYY-MM-DD");
      };

      // Build text content
      let textContent = "=".repeat(80) + "\n";
      textContent += "MALWARE INCIDENT DETAIL REPORT\n";
      textContent += "=".repeat(80) + "\n\n";
      textContent += `Generated on: ${moment().format("YYYY-MM-DD HH:mm:ss")}\n`;
      textContent += `System ID: ${selectedRowDetails._id || "N/A"}\n\n`;

      // Incident Details Section
      textContent += "-".repeat(80) + "\n";
      textContent += "INCIDENT DETAILS\n";
      textContent += "-".repeat(80) + "\n\n";

      const detectedDate = selectedRowDetails?.history && selectedRowDetails.history.length > 0
        ? (selectedRowDetails.history[0]?.log_date
          ? formatDate(selectedRowDetails.history[0].log_date)
          : selectedRowDetails?.fnd
            ? formatDate(selectedRowDetails.fnd)
            : "N/A")
        : selectedRowDetails?.fnd
          ? formatDate(selectedRowDetails.fnd)
          : "N/A";

      textContent += `Detected on: ${detectedDate}\n`;
      textContent += `Hostname: ${selectedRowDetails?.history && selectedRowDetails.history.length > 0
        ? selectedRowDetails.history[0]?.hostname || "N/A"
        : "N/A"}\n`;
      textContent += `Device username: ${selectedRowDetails?.usr || "N/A"}\n`;
      textContent += `IP Address: ${selectedRowDetails?.history && selectedRowDetails.history.length > 0
        ? selectedRowDetails.history[0]?.ip || selectedRowDetails?.iip || "N/A"
        : selectedRowDetails?.iip || "N/A"}\n`;
      textContent += `Operating System: ${selectedRowDetails?.os || "N/A"}\n`;
      textContent += `Malware path: ${selectedRowDetails?.history && selectedRowDetails.history.length > 0
        ? (selectedRowDetails.history[0]?.malware_path
          ? selectedRowDetails.history[0].malware_path.replace(/\\\\/g, "\\")
          : "N/A")
        : "N/A"}\n`;
      textContent += `Anti Virus: ${selectedRowDetails?.history && selectedRowDetails.history.length > 0
        ? selectedRowDetails.history[0]?.anti_virus || selectedRowDetails?.antivirus || "—"
        : selectedRowDetails?.antivirus || "—"}\n`;
      textContent += `Malware Type: ${selectedRowDetails?.mal || "N/A"}\n`;
      textContent += `Hardware ID: ${selectedRowDetails?.hid || "N/A"}\n\n`;

      // Compromised Credentials Section
      textContent += "-".repeat(80) + "\n";
      textContent += "COMPROMISED CREDENTIALS\n";
      textContent += "-".repeat(80) + "\n\n";
      textContent += `Application: ${selectedRowDetails?.src || "N/A"}\n`;
      textContent += `Username: ${selectedRowDetails?.usr || "N/A"}\n`;
      textContent += `Password: ${selectedRowDetails?.pwd ? "***HIDDEN***" : "N/A"}\n\n`;

      // History Section
      if (selectedRowDetails?.history && selectedRowDetails.history.length > 0) {
        textContent += "-".repeat(80) + "\n";
        textContent += `HISTORY (${selectedRowDetails.history.length} record${selectedRowDetails.history.length > 1 ? 's' : ''})\n`;
        textContent += "-".repeat(80) + "\n\n";

        selectedRowDetails.history.forEach((item, index) => {
          textContent += `Record ${index + 1}:\n`;
          textContent += `  Date: ${item?.log_date ? formatDate(item.log_date) : "N/A"}\n`;
          textContent += `  Hostname: ${item?.hostname || "N/A"}\n`;
          textContent += `  IP Address: ${item?.ip || "N/A"}\n`;
          textContent += `  Anti Virus: ${item?.anti_virus || "—"}\n`;
          textContent += `  Malware path: ${item?.malware_path
            ? item.malware_path.replace(/\\\\/g, "\\")
            : "N/A"}\n`;
          textContent += `  Log ID: ${item?.log_id || "N/A"}\n`;
          if (index < selectedRowDetails.history.length - 1) {
            textContent += "\n";
          }
        });
      }

      textContent += "\n" + "=".repeat(80) + "\n";
      textContent += "End of Report\n";
      textContent += "=".repeat(80) + "\n";

      // Create and download text file
      const blob = new Blob([textContent], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const fileName = `Malware_Incident_${selectedRowDetails._id.substring(0, 10)}_${moment().format("YYYY-MM-DD")}.txt`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toastr.success("Success", "Incident details downloaded successfully");
    } catch (error) {
      console.log(error);
      toastr.error("Error", "Failed to download incident details");
    }
  };

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Malware Infected Machine Details (Stealer Logs)</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }

                <li className="breadcrumb-item active" aria-current="page">
                  Malware Infected Machines
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="mb-4">Records Found</h6>
              <div className="d-flex mb-4 justify-content-center">
                {series && series?.length > 0 && <PieChart series={series} label={labels} />}
              </div>

              <div className="form-group">
                <label className="d-block">
                  <span className="greenShadow"></span>
                  Malware Credentials
                  <span className="float-right">
                    {totalRes?.data?.totalMalwareCredentials || 0}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block">
                  <span className="redShadow"></span>
                  Credentials found in last 60 days{" "}
                  <span className="float-right">
                    {totalRes?.data?.totalMalwareCredentialsFoundInLast60Days ||
                      0}
                  </span>
                </label>
              </div>

              <div className="form-group">
                <label className="d-block">
                  <span className="yellowShadow"></span>
                  Types of Malware
                  <span className="float-right">
                    {totalRes?.data?.totalMalwareTypes || 0}
                  </span>
                </label>
              </div>



              {client?.subscriptionType == "trial" && (
                <div className="card border-warning">
                  <TrialComponent />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {oldDnsDetails && (
                <BasicLineColumn
                  dates={oldDnsDetails?.dates}
                  ipArray={ipArray}
                  color={["#08283f"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setSearch("");
              setSelectedIds([]);
              setWorkingCredentials("");
              clearPassword();
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setSearch("");
              setWorkingCredentials("");
              clearPassword();
              setSelectedIds([]);
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setSearch("");
              setWorkingCredentials("");
              clearPassword();
              setSelectedIds([]);
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setSearch("");
              setWorkingCredentials("");
              clearPassword();
              setSelectedIds([]);
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row">
            <div className="col-sm-4 mb-2">
              <div className="searchBoxInput p-0">
                <input
                  class="form-control form-control-sm ml-0 my-1"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    clearPassword();
                    setPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-sm-4 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-4 mb-2">
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Password Length (≤)"
                value={pwdLength}
                onChange={(e) => {
                  const value = e.target.value;
                  setPwdLength(value);
                  setPage(1);
                  clearPassword();
                }}
                min="1"
                style={{ width: "100%" }}
              />
            </div>
            <div className="col-sm-4 mb-2">
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                value={workingCredentials}
                onChange={(e) => {
                  setWorkingCredentials(e.target.value);
                  setPage(1);
                  clearPassword();
                }}
              >
                <option value="">All Credentials</option>
                <option value="true">Working Credentials</option>
                <option value="false">Non-Working Credentials</option>
              </select>
            </div>
            {domainSelected == 'filterOnlyRecordswithUsrSrcDomain' || domainSelected == 'filterUsrDomain'
              || domainSelected == 'filterSrcDomain'
              ?
              <>
                <div className="col-sm-4 mb-2">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    onChange={(e) => { setDomains(e.target.value); setPage(1); clearPassword(); }}
                  >
                    <option value="">
                      Please Select Domain
                    </option>
                    {domainValue?.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </> : null
            }
            <div className="col-sm-4 mb-2">
              {selectedIds.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                        clearPassword();
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemediated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => { Unsnoozed(""); clearPassword(); }}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={
                            selectedIds == 0 ? false : multiCheckTrue
                          }
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th>Found on</th>
                  <th>User</th>
                  <th>Password</th>
                  <th style={{ width: "100px" }}>Source</th>
                  <th>Details</th>
                  {category !== "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th style={{ width: "80" }}>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {client?.subscriptionType == "trial" ? (
                  <tr>
                    <td colSpan={5}>
                      <NoData />
                    </td>
                  </tr>
                ) : (
                  currentTableData?.map((row, index) => {
                    return (
                      <tr key={index}>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <input
                                onClick={() => singleClick(row?._id)}
                                checked={selectedIds?.includes(
                                  row?._id
                                )}
                                type="checkbox"
                                className="checkUncheck"
                              />
                            </td>
                          )}
                        <td>
                          {" "}
                          {row?.createdAt
                            ? moment(row?.fnd).format(
                              "DD-MM-YYYY"
                            )
                            : "NA"}
                        </td>
                        <td
                          style={{
                            whiteSpace: "unset",
                            width: "100px",
                          }}
                        >
                          {row?.usr || "NA"}
                        </td>
                        <td
                          style={{
                            whiteSpace: "unset",
                            width: "100px",
                          }}
                        >
                          <span
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                              display: "flex",
                            }}
                          >
                            <span id={`${row._id}_password`}>
                              ******
                            </span>
                            <i
                              class="fa fa-eye"
                              style={{
                                marginLeft: "10px",
                                cursor: "pointer",
                                fontSize: "16px",
                                color: "#453AD1"
                              }}
                              id={`${row._id}_password_icon`}
                              onClick={() =>
                                toggleIcon(row._id, row?.pwd || "NA")
                              }
                            ></i>
                          </span>
                        </td>
                        <td style={{ width: "100px" }}>
                          {/* <a href={`https://${row?.src}`} target="_blank"> */}
                          <a
                            href={
                              row?.src?.indexOf("https") == -1
                                ? `https://${row?.src}`
                                : `${row?.src}`
                            }
                            target="_blank"
                            style={{ color: "white" }}
                          >
                            {`${row?.src}`}
                          </a>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm"
                            onClick={() => {
                              setSelectedRowDetails(row);
                              setDetailsModal(true);
                              setActiveTab('info');
                            }}
                            style={{
                              backgroundColor: "#17a2b8",
                              borderColor: "#17a2b8",
                              color: "#fff",
                              borderRadius: "4px",
                              padding: "4px 12px",
                              transition: "all 0.3s ease",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px"
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#138496";
                              e.target.style.borderColor = "#117a8b";
                              e.target.style.transform = "translateY(-1px)";
                              e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "#17a2b8";
                              e.target.style.borderColor = "#17a2b8";
                              e.target.style.transform = "translateY(0)";
                              e.target.style.boxShadow = "none";
                            }}
                          >
                            <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                            <span className="details-slider-action-btn-text">Details</span>
                          </button>
                        </td>
                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                          <td>
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze(
                                      row?._id,
                                      event.target.value
                                    );
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                      setLookalikeAppId([row._id]);
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemediated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          </td>
                        )}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed(row?._id)}
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItems > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItems}
                  pageSize={limit}
                  onPageChange={(page) => { setPage(page); clearPassword(); }}
                />
              )}
            </div>
            {totalItems > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add the date picker overlay */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Incident Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
          setActiveTab('info');
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-info-circle mr-2"></i>
              Incident Detail
              {selectedRowDetails?._id && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails._id.substring(0, 50)}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-action-btn"
                onClick={handleDownloadIncident}
                title="Download Incident Details"
              >
                <i className="fa fa-download"></i>
                <span className="details-slider-action-btn-text">Download</span>
              </button>
              {/* <button
                type="button"
                className="details-slider-action-btn"
                onClick={() => setTicketModal(true)}
                title="Create Ticket"
              >
                <i className="fa fa-ticket"></i>
                <span className="details-slider-action-btn-text">Create Ticket</span>
              </button> */}
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                  setActiveTab('info');
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-tabs">
            <button
              className={`details-slider-tab ${activeTab === 'info' ? 'active' : ''}`}
              onClick={() => setActiveTab('info')}
            >
              <i className="fa fa-info-circle mr-2"></i>
              Info
            </button>
            <button
              className={`details-slider-tab ${activeTab === 'history' ? 'active' : ''}`}
              onClick={() => setActiveTab('history')}
            >
              <i className="fa fa-history mr-2"></i>
              History
              {selectedRowDetails?.history && selectedRowDetails.history.length > 0 && (
                <span className="badge-latest ml-2" style={{ fontSize: "0.7rem", padding: "2px 6px" }}>
                  {selectedRowDetails.history.length}
                </span>
              )}
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {activeTab === 'info' && (
                  <>
                    {/* Summary Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-chart-line"></i>
                        Summary
                      </div>
                      {selectedRowDetails?.history && selectedRowDetails.history.length > 0 ? (
                        <>
                          <div className="details-info-item">
                            <span className="details-info-label">Detected on:</span>
                            <span className="details-info-value">
                              {selectedRowDetails.history[0]?.log_date
                                ? (selectedRowDetails.history[0].log_date.includes("-")
                                  ? moment(selectedRowDetails.history[0].log_date).format("YYYY-MM-DD")
                                  : moment(getDate(selectedRowDetails.history[0].log_date)).format("YYYY-MM-DD"))
                                : selectedRowDetails?.fnd
                                  ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                                  : "N/A"}
                              <span className="badge-latest ml-2">Latest</span>
                            </span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">Hostname:</span>
                            <span className="details-info-value">{selectedRowDetails.history[0]?.hostname || "N/A"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">OS:</span>
                            <span className="details-info-value">{selectedRowDetails?.os || "N/A"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">IP:</span>
                            <span className="details-info-value">{selectedRowDetails.history[0]?.ip || selectedRowDetails?.iip || "N/A"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">Anti Virus:</span>
                            <span className="details-info-value">{selectedRowDetails.history[0]?.anti_virus || selectedRowDetails?.antivirus || "—"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">Malware path:</span>
                            <span className="details-info-value">
                              {selectedRowDetails.history[0]?.malware_path
                                ? selectedRowDetails.history[0].malware_path.replace(/\\\\/g, "\\")
                                : "N/A"}
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="details-info-item">
                            <span className="details-info-label">Detected on:</span>
                            <span className="details-info-value">
                              {selectedRowDetails?.fnd
                                ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                                : "N/A"}
                              <span className="badge-latest ml-2">Latest</span>
                            </span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">OS:</span>
                            <span className="details-info-value">{selectedRowDetails?.os || "N/A"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">IP:</span>
                            <span className="details-info-value">{selectedRowDetails?.iip || "N/A"}</span>
                          </div>
                          <div className="details-info-item">
                            <span className="details-info-label">Anti Virus:</span>
                            <span className="details-info-value">{selectedRowDetails?.antivirus || "—"}</span>
                          </div>
                        </>
                      )}
                    </div>

                    {/* What Happened Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-exclamation-triangle"></i>
                        What happened
                      </div>
                      <p style={{ margin: 0, lineHeight: "1.6", color: "#495057" }}>
                        Through our dark web monitoring operations, we identified that the following device and credentials have been compromised by information stealers. The most recent occurrence was observed on{" "}
                        <strong>
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? (selectedRowDetails.history[0]?.log_date
                              ? (selectedRowDetails.history[0].log_date.includes("-")
                                ? moment(selectedRowDetails.history[0].log_date).format("YYYY-MM-DD")
                                : moment(getDate(selectedRowDetails.history[0].log_date)).format("YYYY-MM-DD"))
                              : selectedRowDetails?.fnd
                                ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                                : "N/A")
                            : selectedRowDetails?.fnd
                              ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                              : "N/A"}
                        </strong>
                        .
                      </p>
                      <p style={{ margin: "10px 0 0 0", lineHeight: "1.6", color: "#495057" }}>
                        {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                          ? `Devices of this user have been detected as compromised ${selectedRowDetails.history.length} time${selectedRowDetails.history.length > 1 ? 's' : ''} in our telemetry. ${selectedRowDetails.history.length > 1 ? `${selectedRowDetails.history.length - 1} previous record${selectedRowDetails.history.length > 2 ? 's are' : ' is'} available in the History section.` : ''}`
                          : "Devices of this user have been detected as compromised in our telemetry."}
                      </p>
                    </div>

                    {/* Meta Data Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-database"></i>
                        Meta Data
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">System ID:</span>
                        <span className="details-info-value">{selectedRowDetails?._id || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Log date:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? (selectedRowDetails.history[0]?.log_date
                              ? (selectedRowDetails.history[0].log_date.includes("-")
                                ? moment(selectedRowDetails.history[0].log_date).format("YYYY-MM-DD")
                                : moment(getDate(selectedRowDetails.history[0].log_date)).format("YYYY-MM-DD"))
                              : selectedRowDetails?.fnd
                                ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                                : "N/A")
                            : selectedRowDetails?.fnd
                              ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                              : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Hostname:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? selectedRowDetails.history[0]?.hostname || "N/A"
                            : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Device username:</span>
                        <span className="details-info-value">{selectedRowDetails?.usr || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">IP:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? selectedRowDetails.history[0]?.ip || selectedRowDetails?.iip || "N/A"
                            : selectedRowDetails?.iip || "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">OS:</span>
                        <span className="details-info-value">{selectedRowDetails?.os || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Malware path:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? (selectedRowDetails.history[0]?.malware_path
                              ? selectedRowDetails.history[0].malware_path.replace(/\\\\/g, "\\")
                              : "N/A")
                            : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Anti viruses:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.history && selectedRowDetails.history.length > 0
                            ? selectedRowDetails.history[0]?.anti_virus || selectedRowDetails?.antivirus || "—"
                            : selectedRowDetails?.antivirus || "—"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Malware Type:</span>
                        <span className="details-info-value">{selectedRowDetails?.mal || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Hardware ID:</span>
                        <span className="details-info-value">{selectedRowDetails?.hid || "N/A"}</span>
                      </div>
                    </div>

                    {/* Compromised Credentials Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-key"></i>
                        Compromised Credentials
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Application:</span>
                        <span className="details-info-value">
                          <a
                            href={
                              selectedRowDetails?.src?.indexOf("https") == -1
                                ? `https://${selectedRowDetails?.src}`
                                : `${selectedRowDetails?.src}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#453acd", textDecoration: "none" }}
                          >
                            {selectedRowDetails?.src || "N/A"}
                            <i className="fa fa-external-link ml-1" style={{ fontSize: "0.85em" }}></i>
                          </a>
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Username:</span>
                        <span className="details-info-value">{selectedRowDetails?.usr || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Password:</span>
                        <span className="details-info-value">
                          <span
                            id={`slider_${selectedRowDetails._id}_password`}
                            style={{ fontFamily: "monospace", marginRight: "8px" }}
                          >
                            {selectedRowDetails?.pwd ? "••••••••" : "N/A"}
                          </span>
                          {selectedRowDetails?.pwd && (
                            <button
                              className="btn btn-sm btn-link p-0"
                              onClick={() => {
                                const passwordElement = document.getElementById(`slider_${selectedRowDetails._id}_password`);
                                const iconElement = document.getElementById(`slider_${selectedRowDetails._id}_password_icon`);
                                if (passwordElement) {
                                  if (passwordElement.textContent === "••••••••" || passwordElement.textContent.includes("••••")) {
                                    passwordElement.textContent = selectedRowDetails.pwd;
                                    if (iconElement) {
                                      iconElement.className = "fa fa-eye-slash";
                                    }
                                  } else {
                                    passwordElement.textContent = "••••••••";
                                    if (iconElement) {
                                      iconElement.className = "fa fa-eye";
                                    }
                                  }
                                }
                              }}
                              style={{ border: "none", background: "none", color: "#453acd", padding: "0 5px" }}
                            >
                              <i
                                id={`slider_${selectedRowDetails._id}_password_icon`}
                                className="fa fa-eye"
                                style={{ cursor: "pointer", fontSize: "14px" }}
                              ></i>
                            </button>
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Remediations Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-shield-alt"></i>
                        Remediations
                      </div>
                      <p style={{ margin: 0, lineHeight: "1.6", color: "#495057" }}>
                        Disconnect the infected device from the internet and run a full malware scan. Reset all stored passwords and enable Multi-Factor Authentication (MFA) where possible. Remove any suspicious applications and check for unauthorized system changes. If part of an organization, report the incident to IT/security for further investigation.
                      </p>
                    </div>
                  </>
                )}
                {activeTab === 'history' && (
                  <div className="history-section">
                    <div className="details-section-title" style={{ marginBottom: "20px" }}>
                      <i className="fa fa-history"></i>
                      History
                      {selectedRowDetails?.history && selectedRowDetails.history.length > 0 && (
                        <span className="badge-latest ml-2">{selectedRowDetails.history.length} record{selectedRowDetails.history.length > 1 ? 's' : ''}</span>
                      )}
                    </div>
                    {selectedRowDetails?.history && selectedRowDetails.history.length > 0 ? (
                      <div>
                        {selectedRowDetails.history.map((historyItem, index) => (
                          <div key={index} className="history-item">
                            <div className="history-item-header">
                              <span className="history-item-date">
                                <i className="fa fa-calendar mr-2"></i>
                                {historyItem?.log_date
                                  ? (historyItem.log_date.includes("-")
                                    ? moment(historyItem.log_date).format("YYYY-MM-DD")
                                    : moment(getDate(historyItem.log_date)).format("YYYY-MM-DD"))
                                  : "N/A"}
                              </span>
                              {index === 0 && <span className="badge-latest">Latest</span>}
                            </div>
                            <div className="row" style={{ margin: 0 }}>
                              <div className="col-md-6" style={{ padding: "5px 10px" }}>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>Hostname:</span>
                                  <span className="details-info-value">{historyItem?.hostname || "N/A"}</span>
                                </div>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>OS:</span>
                                  <span className="details-info-value">{selectedRowDetails?.os || "N/A"}</span>
                                </div>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>IP:</span>
                                  <span className="details-info-value">{historyItem?.ip || "N/A"}</span>
                                </div>
                              </div>
                              <div className="col-md-6" style={{ padding: "5px 10px" }}>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>Anti Virus:</span>
                                  <span className="details-info-value">{historyItem?.anti_virus || "—"}</span>
                                </div>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>Malware path:</span>
                                  <span className="details-info-value">
                                    {historyItem?.malware_path
                                      ? historyItem.malware_path.replace(/\\\\/g, "\\")
                                      : "N/A"}
                                  </span>
                                </div>
                                <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                                  <span className="details-info-label" style={{ minWidth: "100px" }}>Log ID:</span>
                                  <span className="details-info-value">{historyItem?.log_id || "N/A"}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="history-item">
                        <div className="history-item-header">
                          <span className="history-item-date">
                            <i className="fa fa-calendar mr-2"></i>
                            {selectedRowDetails?.fnd
                              ? moment(getDate(selectedRowDetails.fnd)).format("YYYY-MM-DD")
                              : "N/A"}
                          </span>
                        </div>
                        <div className="row" style={{ margin: 0 }}>
                          <div className="col-md-6" style={{ padding: "5px 10px" }}>
                            <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                              <span className="details-info-label" style={{ minWidth: "100px" }}>OS:</span>
                              <span className="details-info-value">{selectedRowDetails?.os || "N/A"}</span>
                            </div>
                            <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                              <span className="details-info-label" style={{ minWidth: "100px" }}>IP:</span>
                              <span className="details-info-value">{selectedRowDetails?.iip || "N/A"}</span>
                            </div>
                          </div>
                          <div className="col-md-6" style={{ padding: "5px 10px" }}>
                            <div className="details-info-item" style={{ padding: "5px 0", borderBottom: "none" }}>
                              <span className="details-info-label" style={{ minWidth: "100px" }}>Anti Virus:</span>
                              <span className="details-info-value">{selectedRowDetails?.antivirus || "—"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek identified that credentials associated with this user and endpoint have been
                  <strong> confirmed as compromised</strong> through information-stealing malware. The exposure
                  was detected via dark web intelligence and stealer-log telemetry, indicating that the
                  credentials are already outside the organizational security boundary.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Happened</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      The affected endpoint was infected with an information-stealer malware capable of
                      harvesting saved browser credentials, session tokens, and authentication artifacts.
                      As a result, user credentials linked to this system were exfiltrated and later observed
                      within threat actor infrastructure and dark web sources.
                    </p>
                    <p>
                      The most recent occurrence was detected on the date shown in the incident timeline,
                      confirming that the compromise is not theoretical but has already materialized.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>How Attackers Typically Exploit Such Compromises</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Account takeover using stolen usernames and passwords</li>
                      <li>Session hijacking through stolen cookies or active tokens</li>
                      <li>Unauthorized access to internal portals, email, VPN, or financial systems</li>
                      <li>Lateral movement across systems using reused credentials</li>
                      <li>Fraud, data exfiltration, or business email compromise (BEC)</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why This Incident Is Critical</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Credentials observed in stealer logs must be treated as permanently unsafe</li>
                      <li>Password changes alone are insufficient without session invalidation</li>
                      <li>The presence of malware indicates a broader endpoint security failure</li>
                      <li>Delayed response increases the likelihood of downstream compromise</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Scope of Potential Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Depending on the role and access level of the affected user, the impact may extend to
                      multiple internal and third-party systems. This includes email platforms, payment
                      gateways, administrative portals, cloud services, and any applications where the
                      compromised credentials may have been reused.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Recommended Incident Response Approach</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      This incident should be handled as a <strong>credential compromise caused by malware</strong>,
                      not as a simple password exposure. The response should follow a structured approach:
                    </p>
                    <ul className="checklist-items">
                      <li>Immediate credential revocation and reset across all linked systems</li>
                      <li>Invalidation of active sessions, tokens, and remembered logins</li>
                      <li>Isolation and remediation of the infected endpoint</li>
                      <li>Review of authentication and activity logs for post-compromise abuse</li>
                      <li>Continuous monitoring for reuse or resale of the exposed credentials</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Governance, Compliance & Reporting Considerations</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Credential compromise incidents of this nature should be documented and retained as
                      part of the organization's security incident register. This supports:
                    </p>
                    <ul className="checklist-items">
                      <li>ISO 27001 incident management and evidence requirements</li>
                      <li>RBI Cyber Security Framework expectations for regulated entities</li>
                      <li>CERT-In advisory compliance and post-incident reviews</li>
                      <li>Internal management and audit reporting</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Key Takeaway for Stakeholders</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      The presence of compromised credentials originating from malware indicates an active
                      security incident that requires immediate containment and remediation. Timely action
                      significantly reduces the risk of account takeover, fraud, and broader organizational
                      impact.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Credential Revocation & Reset</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Mark credentials as compromised</li>
                      <li>Force immediate password reset</li>
                      <li>Invalidate active sessions and tokens</li>
                      <li>Block reuse of exposed passwords</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.17 · CERT-In · RBI CSF</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Endpoint & Malware Eradication</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Isolate infected endpoint</li>
                      <li>Remove infostealer malware</li>
                      <li>Validate system integrity post-cleanup</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.7 · CERT-In Malware Handling</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Post-Compromise Investigation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review authentication logs</li>
                      <li>Identify anomalous access</li>
                      <li>Confirm no unauthorized transactions</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.15 · CERT-In Log Review</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Governance, Risk & Reporting</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Record as security incident</li>
                      <li>Document remediation actions</li>
                      <li>Include in audit & regulatory reports</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.24 · RBI Governance</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default MalwareCredentials;
